import React, { useState, useEffect } from "react";
import axiosClient from "../../../utils/axiosClient";
import {
  IonCard,
  IonItem,
  IonLabel,
  IonToggle,
  IonInput,
  IonToast,
} from "@ionic/react";

import { urlAlterar } from "../../../utils/constants";

export default function DiaSemana({ horario, atualizar, resetAtualizar }) {
  const [dia, setDia] = useState(horario.dia);
  const [horario1, setHorario1] = useState(horario.horario_inicial_1);
  const [horario2, setHorario2] = useState(horario.horario_final_1);
  const [horario3, setHorario3] = useState(horario.horario_inicial_2);
  const [horario4, setHorario4] = useState(horario.horario_final_2);
  const [status, setStatus] = useState(horario.status);

  const [colorToast, setColorToast] = useState("");
  const [iconToast, setIconToast] = useState("");
  const [mensagemToast, setMensagemToast] = useState("");
  const [tempoToast, setTempoToast] = useState("");
  const [textoToast, setTextoToast] = useState("");
  const [statusToast, setStatusToast] = useState(false);

  useEffect(() => {
    setDia(horario.dia);
  }, []);

  function obterNomeDoDia(numeroDoDia) {
    const diasDaSemana = [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
    ];

    if (numeroDoDia >= 0 && numeroDoDia <= 6) {
      return diasDaSemana[numeroDoDia];
    } else {
      return "Dia inválido";
    }
  }

  const atualizarDia = async () => {
    try {
      const response = await axiosClient.post(
        urlAlterar("empresas", "configuracoes_horario_atendimento"),
        {
          dia: dia,
          status: status,
          horario_inicial_1: horario1,
          horario_final_1: horario2,
          horario_inicial_2: horario3,
          horario_final_2: horario4,
        }
      );
      if (response.data === 6) {
        setColorToast("success");
        setIconToast("alert-outline");
        setMensagemToast("Horários atualizados com sucesso!");
        setTempoToast(3000);
        setTextoToast("Ok");
        setStatusToast(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (atualizar === 1) {
      atualizarDia();
      if (dia === 6) {
        resetAtualizar(0);
      }
    }
  }, [atualizar, dia]);

  return (
    <IonCard>
      <IonToast
        isOpen={statusToast}
        color={colorToast}
        icon={iconToast}
        message={mensagemToast}
        onDidDismiss={() => setStatusToast(false)}
        duration={tempoToast}
        buttons={[
          {
            text: textoToast,
            role: "info",
            handler: () => {
              return;
            },
          },
        ]}
      ></IonToast>
      <IonItem>
        <IonLabel>{obterNomeDoDia(dia)}</IonLabel>
        {status == 1 ? (
          <IonToggle
            checked="true"
            slot="end"
            color="primary"
            mode="ios"
            onIonChange={() => setStatus(0)}
          ></IonToggle>
        ) : (
          <IonToggle
            slot="end"
            color="primary"
            mode="ios"
            onIonChange={() => setStatus(1)}
          ></IonToggle>
        )}
      </IonItem>

      <div className="ion-margin">
        <div className="row">
          <div className="col-12">
            <br />
            <IonLabel className="ion-padding" style={{ fontSize: "12px" }}>
              Horários referentes ao primeiro período do dia.
            </IonLabel>
            <br />
          </div>
          <div className="col-6">
            <IonItem>
              <IonLabel position="stacked">De: </IonLabel>
              <IonInput
                type="time"
                onIonChange={(e) => setHorario1(e.detail.value)}
                value={horario1}
              />
            </IonItem>
          </div>
          <div className="col-6">
            <IonItem>
              <IonLabel position="stacked">Até: </IonLabel>
              <IonInput
                type="time"
                onIonChange={(e) => setHorario2(e.detail.value)}
                value={horario2}
              />
            </IonItem>
          </div>
          <div className="col-12">
            <br />
            <IonLabel className="ion-padding" style={{ fontSize: "12px" }}>
              Horários referentes ao segundo período do dia.
            </IonLabel>
            <br />
          </div>
          <div className="col-6">
            <IonItem>
              <IonLabel position="stacked">De: </IonLabel>
              <IonInput
                type="time"
                onIonChange={(e) => setHorario3(e.detail.value)}
                value={horario3}
              />
            </IonItem>
          </div>
          <div className="col-6">
            <IonItem>
              <IonLabel position="stacked">Até: </IonLabel>
              <IonInput
                type="time"
                onIonChange={(e) => setHorario4(e.detail.value)}
                value={horario4}
              />
            </IonItem>
          </div>
        </div>
      </div>
    </IonCard>
  );
}
